import { errorHandler } from 'components/ErrorHandler'
import { qrMenuGET } from 'featureSliced/shared/api/qrMenu/GET'
import { AppDispatch } from '../../index'
import { TranslationsSlice } from '.'

export const initTranslations = () => async (dispatch: AppDispatch) => {
  try {
    dispatch(TranslationsSlice.actions.setTranslationsLoading(true))
    const translations = await qrMenuGET.translations()
    dispatch(TranslationsSlice.actions.setTranslations(translations || {}))
    dispatch(TranslationsSlice.actions.setTranslationsLoaded(true))
    dispatch(TranslationsSlice.actions.setTranslationsLoading(false))
  } catch (e) {
    errorHandler(e)
    dispatch(TranslationsSlice.actions.setTranslationsLoaded(true))
    dispatch(TranslationsSlice.actions.setTranslationsLoading(false))
  }
}
